import { Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: "[pageEditStatusContent]",
  standalone: false
})
export class PageEditStatusContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
